/* @flow weak */
import { BankAccount } from 'payments/constants/CopyConstants';
import BoxBody from 'components/BoxBody.jsx';
import cx from 'classnames';
import Dialog from 'components/Dialog.jsx';
import AddBankAccountForm from './AddBankAccountForm.jsx';
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import ToastActions from 'actions/ToastActions';

const AddBankAccountModal = React.createClass({
  propTypes: {
    onBankAccountAdded: React.PropTypes.func,
  },

  onBankAccountAdded(bankAccount) {
    this.props.onRequestHide();
    ToastActions.showSuccessToast('Your bank account was added.');
    if (this.props.onBankAccountAdded) {
      this.props.onBankAccountAdded(bankAccount);
    }
  },

  render() {
    const { className, style, ...rest } = this.props;

    return (
      <Dialog
        eventScreenName="AddBankAccountModal"
        {...rest}
        size="medium"
        style={style}
        className={cx('AddBankAccountModal', className)}>
        <BoxBody>
          <TitleHeader title={BankAccount.title} subtext={BankAccount.subtext} />
          <AddBankAccountForm
            hideChequeImage={false}
            onBankAccountAdded={this.onBankAccountAdded}
          />
        </BoxBody>
      </Dialog>
    );
  },
});

export default AddBankAccountModal;



// WEBPACK FOOTER //
// ./src/payments/components/AddBankAccountModal.jsx